import React from 'react';

import './css/OrdersTablePanel.css';

function OrdersTablePanel({
    searchValue,
    onSearchChange,
    searchPlaceholder = 'Search table…',
    searchAriaLabel = 'Search table',
    resultCount,
    resultLabel = 'order',
    children,
    className = '',
    tableWrapperClassName = '',
}) {
    const count = resultCount ?? 0;
    const plural = count === 1 ? resultLabel : `${resultLabel}s`;

    return (
        <div className={`rich-table-panel orders-rich-table ${className}`.trim()}>
            <div className="orders-rich-table__toolbar">
                <span className="orders-rich-table__count">
                    {count} {plural}
                </span>
                <input
                    type="text"
                    className="orders-rich-table__search"
                    placeholder={searchPlaceholder}
                    value={searchValue}
                    onChange={(e) => onSearchChange(e.target.value)}
                    aria-label={searchAriaLabel}
                    autoComplete="off"
                    spellCheck={false}
                />
            </div>
            <div className={`orders-rich-table__body menu-table-wrapper ${tableWrapperClassName}`.trim()}>
                {children}
            </div>
        </div>
    );
}

export default OrdersTablePanel;
